<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'115px'" :get-action="queryApi" :serial="serial" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- 产品名称 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BjDialogListConfig.SKUname')" prop="skuName">
            <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BjDialogListConfig.SKUname')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- SKU编码 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSearch.table.skuCode')" prop="skuCode">
            <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessStockChange.table.skuCode')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 是否大于0 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockSearch.header.exceedZero')" prop="exceedZero">
            <BjSelectLov v-model="queryParams.exceedZero" :placeholder="$t('BusinessStockSearch.header.exceedZero')" constant-key="STATUS_YES_TRUE" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 客户名称 -->
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="clientCode">
            <BjSelectLov v-model="queryParams.clientCode" :clearable="false" :option-list="clientCodeList" :placeholder="$t('billingPage.CustomerName')" @change="getUserCusid" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" @click="onExport()">{{ $t('exportText') }}</el-button>
          <el-button v-permission:BusinessStorageExportCBM type="primary" @click="onExportCBM()">{{ $t('BusinessStockSearch.exportDetails.button') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'stockNum'">{{ (scope.row.stockNum).toFixed(0) }}</span>
              <span v-else-if="col.prop === 'preemptionNum'">{{ (scope.row.preemptionNum + scope.row.lockNum).toFixed(0) }}</span>
              <span v-else-if="col.prop === 'clientCode'">
                {{ clientCodeList.bjGet(scope.row.skuCode && scope.row.skuCode.split('-').slice(0, 1).join('')) }}
              </span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" align="center">
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog :title="$t('BusinessStockSearch.exportDetails.title')" :visible.sync="storageExportVisible" width="700px" append-to-body>
      <el-form ref="storageExportForm" :model="storageExportForm" :rules="storageExportRules" label-width="160px">
        <el-form-item v-if="!$store.getters.cusId" :label="$t('billingPage.CustomerName')" prop="clientCode">
          <BjSelectLov v-model="storageExportForm.clientCode" :option-list="clientCodeList" :clearable="false" :placeholder="$t('chooseText')" />
        </el-form-item>
        <el-form-item :label="$t('billingPage.Date')" prop="day">
          <el-date-picker v-model="storageExportForm.day" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" :placeholder="$t('chooseText')" style="width: 100%;" />
        </el-form-item>
        <el-form-item :label="$t('BusinessStockSearch.exportDetails.detailType')" prop="category">
          <el-radio-group v-model="storageExportForm.category">
            <el-radio label="CBM">CBM</el-radio>
            <el-radio label="Pallet">{{ $t('BusinessStockSearch.exportDetails.pallet') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <span class="storage-export-hint">{{ $t('BusinessStockSearch.exportDetails.hint') }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="storageExportVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="confirmStorageExport">{{ $t('exportText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi, userApi, billApi } from '@/api';
import { downloadBlob } from '@/utils';
import papa from 'papaparse';

export default {
  name: 'BusinessStockSearchCSG',
  mixins: [pageMiXin],
  data() {
    return {
      queryApi: stockApi.getGoodsStockPageCSG,
      colSpan: 4,
      // 查询参数
      queryParams: {
        exceedZero: true,
        skuName: null,
        skuCode: null,
        clientCode: null,
        warehouseCode: null,
      },
      adminChooseCusId: null,
      storageExportVisible: false,
      storageExportForm: {
        clientCode: null,
        day: null,
        category: 'CBM',
      },
      storageExportRules: {
        clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        day: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        category: [{ required: true, type: 'enum', enum: ['CBM', 'Pallet'], message: this.$t('chooseText'), trigger: 'change' }],
      },
      labelsVersion: 11,
      labelList1: [
        { label: 'BusinessStockSearch.table.skuCode', prop: 'skuCode', isCheck: true, disabled: false },
        { label: 'BjDialogListConfig.SKUname', prop: 'skuName', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.usableNum2', prop: 'usableNum', isCheck: true, disabled: false },
        { label: 'BusinessPurchaseDetailPage.table.Barcode', prop: 'barCode', isCheck: false, disabled: false},
        { label: 'BusinessStockSearch.table.stockNum2', prop: 'stockNum', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.lockNum2', prop: 'preemptionNum', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.warehouseCode', prop: 'warehouseCode', isCheck: true, disabled: false},
        { label: 'BusinessStockSearch.table.warehouseName', prop: 'warehouseName', isCheck: true, disabled: false},
      ],
      labelList2: [
        { label: 'billingPage.CustomerName', prop: 'clientCode', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.skuCode', prop: 'skuCode', isCheck: true, disabled: false },
        { label: 'BjDialogListConfig.SKUname', prop: 'skuName', isCheck: true, disabled: false },
        { label: 'BusinessPurchaseDetailPage.table.Barcode', prop: 'barCode', isCheck: false, disabled: false},
        { label: 'BusinessStockSearch.table.usableNum2', prop: 'usableNum', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.stockNum2', prop: 'stockNum', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.lockNum2', prop: 'preemptionNum', isCheck: true, disabled: false },
        { label: 'BusinessStockSearch.table.warehouseCode', prop: 'warehouseCode', isCheck: true, disabled: false},
        { label: 'BusinessStockSearch.table.warehouseName', prop: 'warehouseName', isCheck: true, disabled: false},
      ],
    };
  },
  computed: {
    labelList() {
      if (this.$store.getters.cusId) {
        return this.labelList1;
      } else {
        return this.labelList2;
      }
    },
  },
  methods: {
    onExportCBM() {
      this.storageExportVisible = true;
      this.$nextTick(() => this.$refs.storageExportForm.resetFields());
    },
    async confirmStorageExport() {
      const valid = await this.$refs.storageExportForm.validate().catch(() => false);
      if (!valid) return;
      const params = {
        ...this.storageExportForm,
        clientCode: this.$store.getters.cusId ? this.$store.getters.userInfo?.clientCode : this.storageExportForm.clientCode,
      };
      try {
        const result = await billApi.getStorageChargeDetailsExport(params);
        if (!(result instanceof Blob) || !result.size) return;
        if (/json|html/i.test(result.type)) {
          const error = await result.text().then(JSON.parse).catch(() => null);
          this.$message.error(error?.msg || this.$t('errorApi'));
          return;
        }
        downloadBlob(result, `${params.clientCode}_${params.category}_${params.day}.csv`);
        this.storageExportVisible = false;
      } catch (error) {}
    },
    getUserCusid(m, n) {
      this.adminChooseCusId = n.cusId;
      this.handleQuery();
    },
    onExport() {
      if (this.$store.getters.cusId) {
        userApi.getClientCode({cusId: this.$store.getters.cusId}).then(res => {
          if (res.message == 'LRI') {
            this.afterExport('stockLRIExport');
          } else {
            this.afterExport('exportGoodsStock');
          }
        });
      } else {
        if (!this.queryParams.clientCode) {
          this.$message.warning(this.$t('BusinessAfterCsgReturn.hintMessageText1'));
        } else {
          userApi.getClientCode({cusId: this.adminChooseCusId}).then(res => {
            if (res.message == 'LRI') {
              this.afterExport('stockLRIExport');
            } else {
              this.afterExport('exportGoodsStock');
            }
          });
        }
      }
    },
    afterExport(val) {
      const firstRow = (this.$refs.BjPage.tableData || [])[0];
      this.queryParams.warehouseCode = firstRow ? firstRow.warehouseCode : null;
      if (!this.queryParams.warehouseCode) {
        return this.$message.warning(`${this.$t('BusinessStockSearch.header.warehouseCode')}: ${this.$t('table.emptyText')}`);
      }
      const fileName = `${this.$t('BusinessStockSearch.table.exportFileName')}.csv`;
      return stockApi.exportGoodsStock(this.queryParams).then(res => {
        if (!res.length) return;
        const csvData = [];
        res.forEach(item => {
          if (val == 'stockLRIExport') {
            csvData.push({
              'sku': item.skuCode,
              'name': item.skuName,
              'description': item.skuDesc,
              'quantity': item.stockNum,
              'activeUnitQuantity': item.lockNum,
              'activeOrderQuantity': item.orderNum || 0,
              'balanceQuantity': item.usableNum,
            });
          } else {
            csvData.push({
              'SKU': item.skuCode,
              'Product Name': item.skuName,
              'Available': item.usableNum,
              'In Stock': item.stockNum,
              'Committed': Number(item.preemptionNum) + Number(item.lockNum),
              'Warehouse Code': item.warehouseCode,
              'warehouse Name': item.warehouseName,
            });
          }
        });
        if (!csvData.length) return;
        const csv = papa.unparse(csvData);
        const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvURL = window.URL.createObjectURL(data);
        const download = document.createElement('a');
        document.body.appendChild(download);
        download.href = csvURL;
        download.setAttribute('download', fileName);
        download.click();
        document.body.removeChild(download);
      });
    },
  },
};
</script>
<style scoped>
.storage-export-hint {
  color: #909399;
  line-height: 1.5;
  word-break: normal;
}

::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
